
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.117.336v2.5h-.781c-.193-.615-.367-.977-.524-1.086-.15-.11-.473-.164-.968-.164h-2.54c-.484 0-.812.055-.984.164-.166.104-.336.466-.507 1.086H1.03v-2.5h7.086zm-4 5.656c-.307 0-.531.052-.672.156-.135.105-.247.336-.336.696h-.671V4.062h.671c.089.37.198.607.329.711.13.1.356.149.68.149h.913c.323 0 .55-.05.68-.149.13-.104.24-.34.328-.71h.672v2.78h-.672c-.088-.359-.203-.59-.344-.695-.135-.104-.356-.156-.664-.156h-.914zM1.04 11L.891 8.219h.78c.131.719.293 1.153.485 1.304.198.151.56.227 1.086.227h2.602c.573 0 .955-.078 1.148-.234.193-.157.354-.589.485-1.297h.78L8.103 11H1.039z","fill":"currentColor"}})])
          )
        }
      }
    